import React from "react";

import * as S from "./styles";

import IBaseProps from "../base-modal/props";
import Modal from "../base-modal";

type IProps = {
  text: string;
  onConfirm: () => void;
} & Omit<IBaseProps, "content">;

const ConfirmModal: React.FC<IProps> = ({ text, onConfirm, ...rest }) => (
  <Modal
    {...rest}
    content={{
      title: text,
      component: () => (
        <S.Container>
          <S.Text>{text}</S.Text>
          <S.ConfirmButton onClick={onConfirm} type="button">
            Ok
          </S.ConfirmButton>
        </S.Container>
      ),
    }}
  />
);

export default ConfirmModal;
